/**
 * Mock event data for CustomLandingPage
 * Uses an inline placeholder image so production build does not 404 and CSP stays tight.
 */

const PLACEHOLDER_IMAGE =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='300' height='200' viewBox='0 0 300 200'%3E%3Crect width='300' height='200' fill='%231a1a2e'/%3E%3Ctext x='150' y='106' text-anchor='middle' font-family='Arial, sans-serif' font-size='28' font-weight='700' fill='%23eeeeee'%3EEvent%3C/text%3E%3C/svg%3E";

export const mockEvents = [
  {
    id: 'taylor-swift-eras',
    title: 'Taylor Swift - Eras Tour',
    dateTime: 'August 15, 2025 @8:00PM',
    venueLocation: 'Wembley Stadium | London, UK',
    subtitle: 'The Eras Tour',
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'Wembley Stadium',
    date: 'Aug 15',
    price: 'From $199',
    category: 'music',
    crew: 'Swifties Unite',
    color: '#ff69b4',
    members: '24.5K',
  },
  {
    id: 'lakers-warriors',
    title: 'Lakers vs. Warriors',
    // NEW: CrewPage-compatible fields
    dateTime: 'October 3, 2025 @7:30PM',
    venueLocation: 'Crypto.com Arena | Los Angeles, CA',
    subtitle: 'NBA Regular Season',
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'Crypto.com Arena',
    date: 'Oct 3',
    price: 'From $85',
    category: 'sports',
    crew: 'Lakers Nation',
    color: '#552583',
    members: '19.8K',
  },
  {
    id: 'hamilton-broadway',
    title: 'Hamilton',
    // NEW: CrewPage-compatible fields
    dateTime: 'September 12, 2025 @8:00PM',
    venueLocation: 'Richard Rodgers Theatre | New York, NY',
    subtitle: 'Broadway Musical',
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'Richard Rodgers Theatre',
    date: 'Sep 12',
    price: 'From $129',
    category: 'theater',
    crew: 'Broadway Fans',
    color: '#8b4513',
    members: '15.3K',
  },
  {
    id: 'electric-daisy',
    title: 'Electric Daisy Carnival',
    // NEW: CrewPage-compatible fields
    dateTime: 'May 19, 2025 @7:00PM',
    venueLocation: 'Las Vegas Motor Speedway | Las Vegas, NV',
    subtitle: 'EDC Las Vegas 2025',
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'Las Vegas Motor Speedway',
    date: 'May 19-21',
    price: 'From $179',
    category: 'music',
    crew: 'EDM Lovers',
    color: '#9d4edd',
    members: '32.1K',
  },
  {
    id: 'drake-tour',
    title: "Drake - It's All A Blur Tour",
    // NEW: CrewPage-compatible fields
    dateTime: 'November 8, 2025 @8:30PM',
    venueLocation: 'Madison Square Garden | New York, NY',
    subtitle: "It's All A Blur Tour",
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'Madison Square Garden',
    date: 'Nov 8',
    price: 'From $145',
    category: 'music',
    crew: 'Drake Fans',
    color: '#ffd700',
    members: '28.7K',
  },
  {
    id: 'celtics-heat',
    title: 'Celtics vs. Heat',
    // NEW: CrewPage-compatible fields
    dateTime: 'December 15, 2025 @7:00PM',
    venueLocation: 'TD Garden | Boston, MA',
    subtitle: 'NBA Regular Season',
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'TD Garden',
    date: 'Dec 15',
    price: 'From $95',
    category: 'sports',
    crew: 'Celtics Pride',
    color: '#007a33',
    members: '22.1K',
  },
  {
    id: 'wicked-broadway',
    title: 'Wicked',
    // NEW: CrewPage-compatible fields
    dateTime: 'January 20, 2026 @7:00PM',
    venueLocation: 'Gershwin Theatre | New York, NY',
    subtitle: 'Broadway Musical',
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'Gershwin Theatre',
    date: 'Jan 20',
    price: 'From $89',
    category: 'theater',
    crew: 'Musical Lovers',
    color: '#228b22',
    members: '18.9K',
  },
  {
    id: 'coachella-2024',
    title: 'Coachella Valley Music Festival',
    // NEW: CrewPage-compatible fields
    dateTime: 'April 12, 2025 @2:00PM',
    venueLocation: 'Empire Polo Club | Indio, CA',
    subtitle: 'Coachella 2025',
    image: PLACEHOLDER_IMAGE,
    status: 'Details',
    // OLD: UI display fields (kept for compatibility)
    venue: 'Empire Polo Club',
    date: 'Apr 12-14',
    price: 'From $429',
    category: 'music',
    crew: 'Festival Squad',
    color: '#ff6347',
    members: '45.2K',
  },
];
